import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { PLAN_REVIEW_QUALITY_GROUP_KEYS } from '../config/justification'

export enum PlanReviewSection {
  Summary = 'overall-business-justification',
  FinancialGrowth = 'financial-growth',
  SobGrowth = 'sob-growth',
  PlanningMeasure = 'planning-measure',
  FinancialPlanCoverage = 'financial-plan-coverage',
  DescriptionQuality = 'description-quality',
  StrategicGrowthAreas = 'strategic-growth-areas',
}

export type TPlanReviewRole = 'hp' | 'manager' | 'partner'

/** The offering whose plan is reviewed. `null` reviews a distributor's plan across every offering,
 *  as its acknowledgment covers them all. */
export type TPlanReviewOffering = ProgramTypes | null

export interface IPlanReviewJustificationTarget {
  key: PlanReviewSection
  label: string
}

export type TPlanReviewQualityGroupKey =
  (typeof PLAN_REVIEW_QUALITY_GROUP_KEYS)[keyof typeof PLAN_REVIEW_QUALITY_GROUP_KEYS]

export interface IPlanReviewJustificationParams {
  PlanQualityGroupKey: TPlanReviewQualityGroupKey
  PlanQualitySectionKey: PlanReviewSection
  FYear: number
  ProgramType: TPlanReviewOffering
  IsGlobal: boolean
  UserEmail: string
  UserFullName: string
}

export interface IPlanReviewJustificationRecord {
  entryId: number
  partnerId: string
  comment: string
  params: IPlanReviewJustificationParams
}

export type TPlanReviewJustifications = Partial<Record<PlanReviewSection, string>>
export type TPlanReviewJustificationRecords = Partial<
  Record<PlanReviewSection, IPlanReviewJustificationRecord>
>

export type TPlanReviewQualitySection = Exclude<PlanReviewSection, PlanReviewSection.Summary>
